/**
 * TikTok glyph, drawn here because `lucide-react` does not ship one.
 *
 * Matches the lucide component API — `className` for sizing and `currentColor`
 * for inheriting the surrounding text color — so it can sit in the same
 * `SOCIAL_LINKS` list as the real lucide icons.
 *
 * TikTok's mark is a filled glyph rather than a stroked one, so it accepts
 * `strokeWidth` only to keep the call sites uniform; the prop is unused.
 */
export function TiktokIcon({ className }: { className?: string; strokeWidth?: number }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" className={className}>
      <path d="M16.6 5.82A4.28 4.28 0 0 0 15.54 3h-3.1v12.4a2.59 2.59 0 1 1-1.85-2.48V9.78a5.68 5.68 0 1 0 4.95 5.63V8.32a7.34 7.34 0 0 0 4.28 1.38V6.6a4.28 4.28 0 0 1-3.22-.78Z" />
    </svg>
  );
}
